/**
 * EU-641 — copy LITERAL do card de aviso "FAQs padrão" por contexto e status
 * (o texto do card do Jira prevalece sobre o Figma: "FAQs padrão" nos dois
 * títulos e "aparecem NA sua vaga"). Registro editável anuncia a escolha
 * (link "Conferir e ocultar perguntas"); Encerrado/Cancelado informa o
 * bloqueio (link "Conferir perguntas") — FQC-024.
 */
export const DEFAULT_FAQS_CARD_TITLE = 'FAQs padrão';

export function defaultFaqsCardCopy(
  context: 'job' | 'program',
  readOnly: boolean
): { body: string; linkLabel: string } {
  if (context === 'program') {
    return readOnly
      ? {
          body: 'Estas são as dúvidas mais comuns de quem se candidata em todos os programas. Como este programa não está mais ativo, as perguntas exibidas não podem ser alteradas.',
          linkLabel: 'Conferir perguntas',
        }
      : {
          body: 'Para facilitar sua vida, já incluímos as dúvidas mais comuns de quem se candidata em todos os programas. Agora você escolhe quais delas aparecem no seu programa.',
          linkLabel: 'Conferir e ocultar perguntas',
        };
  }
  return readOnly
    ? {
        body: 'Estas são as dúvidas mais comuns de quem se candidata em todas as vagas. Como esta vaga não está mais ativa, as perguntas exibidas não podem ser alteradas.',
        linkLabel: 'Conferir perguntas',
      }
    : {
        body: 'Para facilitar sua vida, já incluímos as dúvidas mais comuns de quem se candidata em todas as vagas. Agora você escolhe quais delas aparecem na sua vaga.',
        linkLabel: 'Conferir e ocultar perguntas',
      };
}
